import { useTranslation } from 'react-i18next'
import { Plus } from 'lucide-react'
import { Button } from '@/components/ui/Button.tsx'
import { useGlobalNewIssueEntry } from '@/routes/projectStages/issues/lib/hooks/useGlobalNewIssueEntry.ts'

// Desktop counterpart of the mobile global FAB: the stage-wide "Report" entry
// point, at the top of the stage section of the sidebar. Not a floating
// bottom-right button, which would sit on SlowConnectionPrompt's desktop card.
export default function NavReportIssueButton() {
  const { t } = useTranslation()
  const { available, open } = useGlobalNewIssueEntry()

  if (!available) return null

  return (
    <div className={`px-2 pb-2 md:px-4`}>
      <Button
        type="button"
        onClick={open}
        data-cy="nav-report-issue"
        className={`w-full justify-start gap-2`}
      >
        <Plus className={`size-4`} strokeWidth={2.5} />
        {t('project.issues.reportIssue')}
      </Button>
    </div>
  )
}
